module.exports = __webpack_public_path__ + "media/water-35-default-compression.b5221e18.mp4";